import React from "react";
import Tippy from "@tippy.js/react";
// import Tippy from "@tippyjs/react";

export const Tooltip = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);

export const Tooltippy = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);

export const Tooltipp = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);

Tooltip.defaultProps = {
  animation: "fade",
  arrow: true,
  delay: 150,
  theme: "translucent",
};

Tooltippy.defaultProps = {
  animation: "scale",
  arrow: true,
  delay: 20,
  theme: "translucent",
  placement: "top",
};

Tooltipp.defaultProps = {
  animation: "scale",
  arrow: true,
  delay: 20,
  theme: "light",
  placement: "top",
};

export const Popover = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);
Popover.defaultProps = {
  arrow: true,
  allowHTML: true,
  arrowType: "round",
  duration: 250,
  theme: "ingweb",
  trigger: "click",
  interactive: true,
  placement: "bottom",
};

export const PopoverHeader = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);
Popover.defaultProps = {
  arrow: true,
  allowHTML: true,
  arrowType: "round",
  duration: 250,
  theme: "ingweb",
  interactive: true,
  placement: "bottom",
};

export const PopoverDashboard = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);
PopoverDashboard.defaultProps = {
  arrow: true,
  allowHTML: true,
  arrowType: "round",
  duration: 250,
  theme: "ingwebmanager",
  trigger: "click",
  interactive: true,
  placement: "bottom",
};

export const Topover = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);
Topover.defaultProps = {
  arrow: true,
  allowHTML: true,
  arrowType: "round",
  duration: 250,
  theme: "ingweb",
  interactive: true,
  placement: "top",
};

export const PopoverNotifier = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);
PopoverNotifier.defaultProps = {
  arrow: true,
  allowHTML: true,
  arrowType: "round",
  duration: 70,
  theme: "ingweb",
  interactive: true,
  placement: "bottom-end",
  zIndex: 9998,
};

export const TippyPopper = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);
TippyPopper.defaultProps = {
  arrow: true,
  allowHTML: true,
  arrowType: "round",
  duration: 250,
  theme: "light",
  placement: "right",
};

export const TippyPopper2 = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);
TippyPopper2.defaultProps = {
  arrow: true,
  allowHTML: true,
  arrowType: "round",
  duration: 250,
  theme: "light",
  placement: "left",
};

export const PopoverTransfer = ({ children, ...rest }) => (
  <Tippy {...rest}>{children}</Tippy>
);
PopoverTransfer.defaultProps = {
  arrow: true,
  allowHTML: true,
  arrowType: "round",
  theme: "ingweb",
  trigger: "click",
  interactive: true,
  placement: "bottom",
};

export const PopoverAttendance = ({
  children,
  visible,
  onClickOutside,
  trigger: triggerProp,
  ...rest
}) => {
  const isControlled = typeof visible !== "undefined";
  const trigger = isControlled
    ? "manual"
    : typeof triggerProp !== "undefined"
    ? triggerProp
    : "click";

  return (
    <Tippy
      trigger={trigger}
      visible={visible}
      onClickOutside={onClickOutside}
      {...rest}
    >
      {children}
    </Tippy>
  );
};
PopoverAttendance.defaultProps = {
  arrow: true,
  allowHTML: true,
  arrowType: "round",
  duration: 250,
  theme: "ingweb",
  trigger: "click",
  interactive: true,
  placement: "bottom",
};
